<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a (click)="cancelEvent.emit()">
            <img src="assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="lpc-back-icon" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_menu_settings" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body">
    <form>
        <div class="form-group mb-10">
            <label>
                {{ "control_name" | translate }}
            </label>
            <div>
                <input class="form-control" value="Home" [formControl]="name" />
            </div>
        </div>

        <div class="form-group mb-20">
            <label>
                {{ LINK_TYPE_NAME[linkType.value] | translate }}
            </label>
            <div class="input-group">
                <div class="input-group-btn type-dropdown" dropdown>
                    <button dropdownToggle type="button" class="btn btn-default type-dropdown-toggle">
                        <img
                            class="element-icon mr-10"
                            src="./assets/img/websites/forms-icons/lpc-f-{{ linkType.value }}-icon.svg"
                            alt="url-icon"
                        />
                        <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu" *dropdownMenu>
                        <ng-container *ngFor="let option of LINK_TYPES">
                            <li [class.selected]="option.type === linkType.value" (click)="setLinkType(option)">
                                <a>
                                    <span class="dropdown-icon mr-10">
                                        <img
                                            src="./assets/img/websites/forms-icons/lpc-f-{{ option.type }}-icon.svg"
                                            [alt]="option.type"
                                        />
                                    </span>
                                    {{ option.name | translate }}
                                </a>
                            </li>
                        </ng-container>
                    </ul>
                </div>
                <input
                    class="form-control"
                    [placeholder]="BUTTON_LINK_TYPE_PLACEHOLDER[linkType.value]"
                    [formControl]="linkUrl"
                />
            </div>

            <!-- Показываем если выбран тип "Ссылка" -->
            <small class="help-block text-muted" *ngIf="linkType.value === EButtonLinkType.link && pages.length">
                <span class="p-relative" dropdown>
                    <a class="dotted-toggle" dropdownToggle>
                        <span>{{ "control_choose_page" | translate }}</span> <span class="caret"></span>
                    </a>
                    <ul class="dropdown-menu" *dropdownMenu>
                        <li *ngFor="let item of pages">
                            <a (click)="setLinkData(item.id, item.name)"
                                >{{ item.name }}<br /><small class="text-muted">{{ item.id }}</small></a
                            >
                        </li>
                    </ul>
                </span>
            </small>

            <!-- Показываем если выбран тип "Якорь" -->
            <!--            <small class="help-block text-muted" *ngIf="linkType.value === 'anchor'">-->
            <!--                <span class="p-relative" dropdown>-->
            <!--                    <a class="dotted-toggle" dropdownToggle>-->
            <!--                        &lt;!&ndash; TODO: translations &ndash;&gt;-->
            <!--                        <span>Выбрать блок</span> <span class="caret"></span>-->
            <!--                    </a>-->
            <!--                    <ul class="dropdown-menu" *dropdownMenu>-->
            <!--                        <li>-->
            <!--                            <a>-->
            <!--                                Первый экран<br>-->
            <!--                                <small class="text-muted">#id-56872</small>-->
            <!--                            </a>-->
            <!--                        </li>-->
            <!--                        <li>-->
            <!--                            <a>-->
            <!--                                О нас<br>-->
            <!--                                <small class="text-muted">#id-56875</small>-->
            <!--                            </a>-->
            <!--                        </li>-->
            <!--                    </ul>-->
            <!--                </span>-->
            <!--            </small>-->
        </div>

        <div class="form-group form-horizontal row" *ngIf="linkType.value === EButtonLinkType.link">
            <label class="control-label col-xs-9">
                {{ "control_target" | translate }}
            </label>
            <div class="col-xs-3 control-switch text-right">
                <sp-switch [active]="isTargetBlank.value" (toggleActiveEvent)="setTargetBlank($event)"></sp-switch>
            </div>
        </div>
    </form>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()"></web-settings-footer>
